import { Classes } from '@blueprintjs/core';
import { classNames } from '../../utils/classNames';
import styles from './AceTag.module.css';

export interface IAceTag {
  children?: string;
  classes?: IClasses;
  size?: 'small' | 'medium' | 'large';
  square?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

interface IClasses {
  root?: string;
  tag?: string;
}

export function AceTag({
  children,
  classes,
  size = 'medium',
  square = false,
  onClick,
}: IAceTag) {
  const sizeClass = {
    xsmall: styles.xsmall,
    small: Classes.TEXT_SMALL,
    medium: '',
    large: Classes.TEXT_LARGE,
  };

  const buttonWithChildren = (
    <button
      type="button"
      className={classNames(
        styles.aceTag,
        square ? styles.square : '',
        classes?.tag ? classes.tag : '',
        sizeClass[size],
      )}
      onClick={onClick}
    >
      <span>{children}</span>
    </button>
  );

  const nonButtonChildren = (
    <div
      className={classNames(
        styles.aceTag,
        square ? styles.square : '',
        classes?.tag ? classes.tag : '',
        sizeClass[size],
      )}
    >
      <span>{children}</span>
    </div>
  );

  const renderedChildren = onClick ? buttonWithChildren : nonButtonChildren;

  return (
    <div className={classNames(styles.container, classes?.root)}>
      {renderedChildren}
    </div>
  );
}
